import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { cn } from '../../lib/utils';
import { useTheme } from '../../context/ThemeContext';

/** Horizontal share bars — concentration without another pie. */
export function ConcentrationStrip({
  title = 'Share of total',
  rows = [],
  className,
}) {
  const { chartPalette } = useTheme();
  if (!rows.length) return null;
  const maxShare = Math.max(...rows.map((row) => row.share), 1);

  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="px-4 py-2.5">
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2.5 px-4 py-3">
        {rows.map((row, index) => (
          <div key={row.id} className="min-w-0">
            <div className="mb-1 flex items-center justify-between gap-2 text-xs">
              <p className="min-w-0 truncate font-medium text-[#201C35]" title={row.name}>
                {row.name}
              </p>
              <span className="shrink-0 tabular-nums font-semibold text-slate-600">
                {Number(row.share || 0).toFixed(1)}%
              </span>
            </div>
            <div className="h-2 overflow-hidden rounded-full bg-slate-100">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${Math.max((row.share / maxShare) * 100, 4)}%`,
                  backgroundColor: chartPalette[index % chartPalette.length],
                }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
